import { useState, useEffect } from "react";

const getHeight = () => {
  if (typeof window === "undefined") {
    return "100vh";
  }
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  );
};

export function useCurrentWindowHeight() : (number|string) {
  // save current window height in the state object
  let [height, setHeight] = useState<number|string>(getHeight());

  // in this case useEffect will execute only once because
  // it does not have any dependencies.
  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId: ReturnType<typeof setInterval>;
    let isMounted: boolean = true;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change height from the state object after 150 milliseconds
      timeoutId = setTimeout(() => {
        if (isMounted) {
          setHeight(getHeight());
        }
      }, 150);
    };
    // set resize listener
    window.addEventListener("resize", resizeListener);

    // clean up function
    return () => {
      isMounted = false;
      // remove resize listener
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return height;
}
